import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  MASTER_HARDWARE_CATALOG_LIST,
  MASTER_HARDWARE_CATALOG_CREATE,
  MASTER_HARDWARE_CATALOG_UPDATE,
  MASTER_HARDWARE_CATALOG_DELETE,
} from "./actionType";

import {
  masterHardwareCatalogListSuccess,
  masterHardwareCatalogListFailure,
  masterHardwareCatalogCreateSuccess,
  masterHardwareCatalogCreateFailure,
  masterHardwareCatalogUpdateSuccess,
  masterHardwareCatalogUpdateFailure,
  masterHardwareCatalogDeleteSuccess,
  masterHardwareCatalogDeleteFailure,
} from "./action";

import {
  getMasterHardwareCatalogList,
  createMasterHardwareCatalog,
  updateMasterHardwareCatalog,
  deleteMasterHardwareCatalog,
} from "../../helpers/fakebackend_helper";

// LIST
function* fetchMasterHardwareCatalogList() {
  try {
	const response = yield call(getMasterHardwareCatalogList);
	yield put(masterHardwareCatalogListSuccess(response));
  } catch (error) {
	yield put(masterHardwareCatalogListFailure(error));
  }
}
function* watchFetchMasterHardwareCatalogList() {
  yield takeEvery(MASTER_HARDWARE_CATALOG_LIST, fetchMasterHardwareCatalogList);
}

// CREATE
function* createMasterHardwareCatalogSaga(action) {
  try {
	const response = yield call(createMasterHardwareCatalog, action.payload);
	yield put(masterHardwareCatalogCreateSuccess(response));
  } catch (error) {
	yield put(masterHardwareCatalogCreateFailure(error));
  }
}
function* watchCreateMasterHardwareCatalog() {
  yield takeEvery(MASTER_HARDWARE_CATALOG_CREATE, createMasterHardwareCatalogSaga);
}

// UPDATE
function* updateMasterHardwareCatalogSaga(action) {
  try {
	const response = yield call(updateMasterHardwareCatalog, action.payload);
	yield put(masterHardwareCatalogUpdateSuccess(response));
  } catch (error) {
	yield put(masterHardwareCatalogUpdateFailure(error));
  }
}
function* watchUpdateMasterHardwareCatalog() {
  yield takeEvery(MASTER_HARDWARE_CATALOG_UPDATE, updateMasterHardwareCatalogSaga);
}

// DELETE
function* deleteMasterHardwareCatalogSaga(action) {
  try {
	const response = yield call(deleteMasterHardwareCatalog, action.payload);
	yield put(masterHardwareCatalogDeleteSuccess(response));
  } catch (error) {
	yield put(masterHardwareCatalogDeleteFailure(error));
  }
}
function* watchDeleteMasterHardwareCatalog() {
  yield takeEvery(MASTER_HARDWARE_CATALOG_DELETE, deleteMasterHardwareCatalogSaga);
}

export default function* masterHardwareCatalogSaga() {
  yield all([
	fork(watchFetchMasterHardwareCatalogList),
	fork(watchCreateMasterHardwareCatalog),
	fork(watchUpdateMasterHardwareCatalog),
	fork(watchDeleteMasterHardwareCatalog),
  ]);
}


